import BaseComponent from 'scripts/BaseComponent.js';
import { isSameDayAvailable } from 'scripts/helpers/deliverySelection.js';

export default class CollectionDeliverySelectionForm extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      input: '.js-zipcodeSearchInput',
      titleSection: '.js-collectionTitleDeliverySelection',
      btn: '.js-deliverySelectionBtn',
    };

    this.dom = {
      $component: component,
      $input: this.$get(this.refs.input),
      $titleSection: document.querySelector(this.refs.titleSection),
      $btns: this.$getAll(this.refs.btn),
    };

    this.state = {
      selectedZipCode: null,
      selectedDeliveryOption: null,
      sameDayCutoff: 14, // 2:00 pm
      sameDayActiveClass: 'same-day-active',
      nextDayActiveClass: 'next-day-active',
      activeBtnClass: 'is-active',
      zipcodeSelectedEvent: 'zipcodeselected',
      updateCoastFilterEvent: 'updatecoastfilter',
    };

    this.init();
    this.mount();
  }

  mount() {
    const { dom, state } = this;
    super.mount();

    this.setClickWithElement(dom.$btns, this.handleDeliverySelection);
    this.setOnCustomEvent(state.zipcodeSelectedEvent, this.handleZipCodeChange);
  }

  init() {
    const { searchParams } = new URL(document.location);

    this.setZipcodeInputValue(
      searchParams.get('zipcode'),
      searchParams.get('filter.p.m.custom.concierge_coast'),
    );

    this.setActiveDeliveryState(
      searchParams.get('delivery'),
    );
  }

  setZipcodeInputValue(zipcode, coast) {
    const { dom, state } = this;
    if (!zipcode || !coast) return;

    state.selectedZipCode = { zipcode, coast };
    dom.$input.value = zipcode;
  }

  setActiveDeliveryState(delivery) {
    const { state, refs } = this;
    const sameDayAvailable = this.getSameDayAvailable();
    const sameDayBtn = this.$get(`${refs.btn}[data-value="same_day"]`);

    if (sameDayAvailable) {
      state.selectedDeliveryOption = delivery || 'same_day';
      sameDayBtn.removeAttribute('disabled');
    } else {
      state.selectedDeliveryOption = 'next_day';
      sameDayBtn.disabled = true;
    }

    this.setActiveDeliveryDom();
  }

  setActiveDeliveryDom() {
    const { dom, state, refs } = this;

    dom.$btns.forEach((btn) => { btn.classList.remove(state.activeBtnClass); });

    if (state.selectedDeliveryOption === 'same_day') {
      dom.$titleSection.classList.remove(state.nextDayActiveClass);
      dom.$titleSection.classList.add(state.sameDayActiveClass);
      this.$get(`${refs.btn}[data-value="same_day"]`).classList.add(state.activeBtnClass);
    } else {
      dom.$titleSection.classList.remove(state.sameDayActiveClass);
      dom.$titleSection.classList.add(state.nextDayActiveClass);
      this.$get(`${refs.btn}[data-value="next_day"]`).classList.add(state.activeBtnClass);
    }
  }

  getSameDayAvailable() {
    const { state } = this;
    if (!state.selectedZipCode) return false;

    return isSameDayAvailable(state.selectedZipCode.coast, state.sameDayCutoff);
  }

  handleDeliverySelection(btn) {
    const { state } = this;
    const { value } = btn.dataset;
    if (state.selectedDeliveryOption === value) return;

    state.selectedDeliveryOption = value;
    this.setActiveDeliveryDom();
  }

  handleZipCodeChange({ detail: { zipcode, coast } }) {
    const { state } = this;
    const currentCoast = state.selectedZipCode ? state.selectedZipCode.coast : null;
    if (currentCoast === coast) return;

    state.selectedZipCode = { zipcode, coast };
    this.setActiveDeliveryState();
    this.dispatch(state.updateCoastFilterEvent, { coast });
  }
}
